import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { editLocation, loadProvider } from 'actions/provider';
import ModalContent from 'atoms/modal-content';
import toast from 'atoms/toast';
import { HourBlocks } from 'organisms/HourBlocks';
import { formatApiHours } from 'pages/Profile/util';
import { initLocationForm } from 'store/reducers/locationForm';
import { formatWebsite, prettifyHoursData } from 'util';

function EditHoursModal({ isOpen, openModal }) {
  const dispatch = useDispatch();
  const providerInfo = useSelector((state) => state.provider);
  const locationInfo = providerInfo.locations[0];
  const locationForm = useSelector((state) => state.locationForm);
  const [hours, setHours] = useState({
    Monday: {},
    Tuesday: {},
    Wednesday: {},
    Thursday: {},
    Friday: {},
    Saturday: {},
    Sunday: {},
  });

  useEffect(() => {
    setHours(formatApiHours(locationInfo.hours, hours));
    dispatch(initLocationForm({ ...locationInfo, name: providerInfo.name }));
  }, []);

  const onSave = () => {
    const body = {
      ...locationForm,
      email: locationInfo.email,
      countryCodeId: locationForm.countryCodeId.code.id,
      hours: prettifyHoursData(hours),
      website: formatWebsite(locationForm.website),
    };

    dispatch(editLocation(body)).then(({ success }) => {
      if (success) {
        dispatch(loadProvider());
        toast({ text: 'Information saved!' });
      }
    });
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={() => openModal(false)}
      shouldCloseOnOverlayClick
      className="edit-info-modal"
    >
      <ModalContent
        title="When are you open?"
        primaryButton="Save"
        secondaryButton="Close"
        primaryButtonAction={onSave}
        secondaryButtonAction={() => openModal(false)}
        onClose={() => openModal(false)}
      >
        <HourBlocks hours={hours} setHours={setHours} hideTitle />
      </ModalContent>
    </Modal>
  );
}

export default EditHoursModal;
